// File generated by PostBuildApiClientController
import { HttpApiClient } from "./HttpApiClient";
import { HttpApiRequestOptions } from "./HttpApiRequestOptions";
import { Injectable } from "@angular/core";
import { BankMovementDto } from "../dtos/BankMovementDto";
import { PagedResultDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedResultDto";
import { BankMovementFiltersDto } from "../dtos/BankMovementFiltersDto";
import { PagedSearchDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto";

@Injectable({providedIn: 'root'})
export class ApiAdminBankMovement {
  constructor(private _httpApiClient: HttpApiClient) {
    // Empty constructor
  }

  getById(
    id: string,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<BankMovementDto> {
    return this._httpApiClient.get("/admin/bank-movement/" + id, httpApiRequestOptions);
  }

  getPaged(
    filters: PagedSearchDto<BankMovementFiltersDto>,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<PagedResultDto<BankMovementDto>> {
    return this._httpApiClient.post("/admin/bank-movement/paged", filters, httpApiRequestOptions);
  }

  getFromDaMap(httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<void> {
    return this._httpApiClient.get("/admin/bank-movement/get-from-damap", httpApiRequestOptions);
  }

}
